'use client';

import { useState } from 'react';
import { Button } from './button';
import { EmptyView } from './empty-view';

export interface QueryErrorPanelProps {
  /** Called when the user clicks "Try again" — typically the errored queries' `retry` from `combineQueryStates`. */
  onRetry: () => unknown;
  title?: string;
  description?: string;
}

/** Page-level error state for a failed query, composed from `EmptyView` + `Button`. */
export function QueryErrorPanel({
  onRetry,
  title = "Couldn't load this page",
  description = 'Something went wrong fetching the data. Your session may have expired.',
}: QueryErrorPanelProps) {
  const [retrying, setRetrying] = useState(false);

  const handleRetry = async () => {
    setRetrying(true);
    try {
      await onRetry();
    } finally {
      setRetrying(false);
    }
  };

  return (
    <div role="alert">
      <EmptyView
        title={title}
        description={description}
        action={
          <Button variant="outline" onClick={handleRetry} disabled={retrying}>
            {retrying ? 'Retrying…' : 'Try again'}
          </Button>
        }
      />
    </div>
  );
}
